import { ICON_SIZE } from "@/config/constants";
import { Button, Input, InputProps } from "@heroui/react";
import { PlusIcon } from "@phosphor-icons/react";
import { useState } from "react";

interface TagInputProps extends InputProps {
  onAddTag?: (tagName: string) => void;
  onValueChange?: (value: string) => void;
}

export function TagInput({ onAddTag, onValueChange, onKeyDown, ...rest }: TagInputProps) {
  const [tagName, setTagName] = useState("");

  const handleAddTag = () => {
    if (!tagName || !onAddTag) return;
    onAddTag?.(tagName);
    setTagName("");
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTagName(value);
    onValueChange?.(value);
  };

  const handleInputKeyDown = (e: React.KeyboardEvent) => {
    onKeyDown?.(e as React.KeyboardEvent<HTMLInputElement>);
    if (e.key === "Enter") {
      handleAddTag();
    }
  };
  return (
    <Input
      endContent={
        Boolean(tagName) && (
          <Button className="h-5 w-5 min-w-5" isIconOnly size="sm" variant="light" onPress={handleAddTag}>
            <PlusIcon size={ICON_SIZE.sm} />
          </Button>
        )
      }
      key="tag-input"
      placeholder="New tag name"
      value={tagName}
      onChange={handleInputChange}
      onKeyDown={handleInputKeyDown}
      onClick={(e) => e.stopPropagation()}
      {...rest}
    />
  );
}
